<div
    class="w-full flex flex-col divide-y divide-gray-100 dark:divide-white/10 overflow-hidden shadow-card-container-pale">
    <div class="shrink-0 p-2 flex flex-row flex-wrap items-center justify-between gap-2">
        <div class="flex min-w-0 items-center flex-1">
            <div class="shrink-0">
                <div
                    class="size-10 rounded-xl bg-cyan-500/20 text-cyan-500 text-sm font-semibold flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-6">
                        <rect width="18" height="18" x="3" y="3" rx="2" />
                        <path d="M7 3v18" />
                        <path d="M3 7.5h4" />
                        <path d="M3 12h18" />
                        <path d="M3 16.5h4" />
                        <path d="M17 3v18" />
                        <path d="M17 7.5h4" />
                        <path d="M17 16.5h4" />
                    </svg>
                </div>
            </div>
            <div class="ml-4 min-w-0">
                <h3 class="text-md font-semibold text-primary">Videos to Review</h3>
                <p class="text-sm text-secondary">
                    5 newly uploaded · awaiting your approval before they can be posted
                </p>
            </div>
        </div>


    </div>
    <div class="flex-1 flex flex-col p-2">



        @if (videosToReview() && videosToReview()!.length > 0) {

        <div class="w-full overflow-hidden">
            <div class="flex flex-row gap-x-3 overflow-x-auto scrollbar-transparent pb-2">
                @for (video of videosToReview()!; track video.id) {
                <div
                    class="flex-none w-36 sm:w-40 flex flex-col divide-y divide-gray-200 text-center card-container-white self-start">
                    <div class="overflow-hidden">
                        <mgc-portfolio-inline-video [video]="video"></mgc-portfolio-inline-video>

                        <div class="pt-2 flex flex-col gap-y-2">
                            <div class="flex flex-row w-full items-center justify-between">
                                <div class="flex-1 truncate">
                                    <div class="flex items-start space-x-3">
                                        <h3 class="truncate text-sm font-medium text-primary">{{ video.creator.firstName
                                            }} {{ video.creator.lastName.charAt(0).toUpperCase() }}</h3>
                                    </div>
                                    <p class="truncate text-xs text-secondary text-start">{{ video.videoName }}</p>
                                </div>
                                <div class="shrink-0 flex items-center justify-center">
                                    <button (click)="goToViewSubmission(video)" type="button"
                                        class="btn-fab-primary">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                            <path d="M21 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6" />
                                            <path d="m21 3-9 9" />
                                            <path d="M15 3h6v6" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                }
            </div>
        </div>


        } @else if (videosToReview() && videosToReview()!.length == 0) {
        <div class="w-full flex flex-col items-center justify-center p-4 h-full">
            <div class="text-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="mx-auto size-12 text-gray-400 dark:text-gray-500">
                    <rect width="18" height="18" x="3" y="3" rx="2" />
                    <path d="M7 3v18" />
                    <path d="M3 7.5h4" />
                    <path d="M3 12h18" />
                    <path d="M3 16.5h4" />
                    <path d="M17 3v18" />
                    <path d="M17 7.5h4" />
                    <path d="M17 16.5h4" />
                </svg>
                <h3 class="mt-2 text-sm font-semibold text-primary">No videos to review</h3>
                <p class="mt-1 text-sm text-secondary">You're all caught up!</p>
            </div>
        </div>
        } @else {
        <div class="w-full overflow-hidden">
            <div class="flex flex-row gap-x-3 overflow-x-auto scrollbar-transparent pb-2">
                @for (video of [0,1,2,3,4,5]; track $index) {
                <div
                    class="flex-none w-36 sm:w-40 flex flex-col divide-y divide-gray-200 text-center card-container-white self-start">
                    <div class="overflow-hidden">


                        <div class="thumbnail-container video-portrait">
                            <!-- Skeleton base -->
                            <div class="absolute inset-0 bg-neutral-quaternary rounded-lg"></div>
                            <!-- Play button hint -->
                            <div class="absolute inset-0 flex items-center justify-center">
                                <div class="w-11 h-11 rounded-full bg-white/10 flex items-center justify-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                        class="w-5 h-5 text-white/20 translate-x-0.5" aria-hidden="true">
                                        <path d="M8 5.14v14l11-7-11-7z" />
                                    </svg>
                                </div>
                            </div>
                            <!-- Metadata lines at bottom -->
                            <div class="absolute bottom-0 left-0 right-0 p-3 space-y-2">
                                <div class="h-2 rounded-full bg-white/10 w-3/4"></div>
                                <div class="h-2 rounded-full bg-white/10 w-1/2"></div>
                            </div>
                            <!-- Shimmer sweep -->
                            <div class="skeleton-shimmer rounded-lg"></div>
                        </div>

                    </div>
                </div>
                }
            </div>
        </div>
        }
    </div>
</div>